import {
  Div, FormLayout, Group, Panel, PanelHeader, PanelHeaderBack, ScreenSpinner
} from '@vkontakte/vkui';
import { useUnit } from 'effector-react';
import { memo, useMemo } from 'react';
import { AppPanels, AppPanelsT } from 'src/app/providers/RouteProvider/lib/routeConfig';
import { setActivePanel } from 'src/entity/ActivePanel';
import { $pollItems, PretendentsGate } from 'src/entity/Pretendents';
import { Cover } from 'src/shared/ui/cover';
import { SuperBtn } from 'src/shared/ui/superBtn';
import { Title } from '../../../shared/ui/title/Title';
import { WinnerCard } from './WinnerCard/WinnerCard';
import styles from './styles.module.scss';

export interface ISecondstageNominatiosPanel {
  id: AppPanelsT;
}

// Событие отслеживания успешной отправки формы вынесено в модель, т.к. отсутствует роутинг

export const SecondstageNominatiosPanel = memo(
  ({ id }: ISecondstageNominatiosPanel) => {
    const [
      pollItems,
      onSetActivePanel
    ] = useUnit([
      $pollItems,
      setActivePanel
    ]);

    const nominationCards = useMemo(
      () => pollItems.map(({
        name,
        label,
        nominees
      }) => (
        <WinnerCard
          key={name}
          name={name}
          label={label}
          winner={nominees[0]}
        />
      )),
      [pollItems]
    );

    const onSendClickHandler = () => {
      onSetActivePanel(AppPanels.FINAL);
    };

    const onBackClickHandler = () => {
      onSetActivePanel(AppPanels.INTRO);
    };

    return (
      <>
        <PretendentsGate />
        <Panel id={id}>
          <PanelHeader
            visor={false}
            separator={false}
            transparent
            style={{ width: '0px' }}
            before={(
              <PanelHeaderBack
                onClick={onBackClickHandler}
              />
            )}
          />
          {!pollItems.length ? (<ScreenSpinner />)
            : (
              <Group>
                <Title align='center' size='s'>
                  Победители премии
                  <br />
                  «Главные герои - 2023»
                  <br />
                </Title>
                <Div className={styles.poll__form}>
                  <FormLayout className={styles.form}>
                    {nominationCards}
                    <SuperBtn
                      color='3'
                      size='m'
                      className={styles.button}
                      text='Установить эмодзи статус'
                      onClick={onSendClickHandler}
                    />
                  </FormLayout>
                </Div>
              </Group>
            )}
          <Cover />
        </Panel>
      </>
    );
  }
);
